/**
 * 共通定数
 *
 * @summary よく使う変数たち
 */

export const BODY_ELEMENT = document.body;
export const HTML_ELEMENT = document.documentElement;
export const SCROLL_ELEMENT = document.scrollingElement || HTML_ELEMENT;
export const FOCUS_ELEMENTS = 'a[href], area[href], [tabindex], button, input, select, textarea, iframe, object, audio, video, embed, summary';
export const STORAGE = window.localStorage;
export const LOCATION = {
    href: window.location.href,
    path: window.location.pathname,
    hash: window.location.hash,
    param: window.location.search
};
export const headerHeight = 136;
export const mql = window.matchMedia('(min-width: 769px)');
export const resizeEvent = {
    start: 'resizestart',
    end: 'resizeend'
};

/**
 * ローカルストレージから値を取得
 * @param  {string} key - 取得したいストレージのキー名
 * @return {string|null|false} 取得できた場合保存されている文字列を返却・それ以外はfalseを返却
 */
export const getStorageItem = (key) => {
    try {
        return STORAGE.getItem(key);
    } catch (e) {
        // localStorageが使えない場合の処理
    }

    return false;
};

/**
 * ローカルストレージに値を保存
 * @param  {string} key - 保存したいストレージのキー名
 * @param  {string} value - 保存したい内容
 * @return {boolean} - 保存ができたか否か
 */
export const setStorageItem = (key, value) => {
    try {
        STORAGE.setItem(key, value);

        return true;
    } catch (e) {
        // localStorageが使えない場合の処理
    }

    return false;
};

/**
 * ランダム文字列生成
 * @param  {string} [prefix] - ランダム文字列の接頭辞
 * @return {string} - 接頭辞 ＋ ランダム文字列
 */
export const randomString = (prefix) => {
    const str = `${prefix || 'id'}${Math.random().toString(36).slice(-8)}`;

    // 重複するIDがHTML内に存在する場合、再生成
    if (document.getElementById(str)) {
        return randomString(prefix);
    }

    return str;
};

/**
 * tabIndex制御
 * @param  {Boolean} isSet - tabindex="-1"をセットする(true)しない（false）
 * @param  {NodeList | HTMLElement[]} ignoreElements - tabindexを変更する要素（省略可能、省略した場合すべてのフォーカス可能要素を対象とする）
 * @return {void}
 */
export const tabindexControl = (isSet, ignoreElements) => {
    /** @type {NodeListOf<HTMLElement>} */
    const allFocusableElements = (document.querySelectorAll(FOCUS_ELEMENTS));
    const ignore = ignoreElements || [];

    if (isSet) {
        for (const element of allFocusableElements) {
            if ([].indexOf.call(ignore, element) !== -1) {
                continue;
            }

            if (element.tabIndex !== undefined) {
                element.dataset.tabindex = String(element.tabIndex);
            }

            element.tabIndex = -1;
        }
    } else {
        for (const element of allFocusableElements) {
            if ([].indexOf.call(ignore, element) !== -1) {
                continue;
            }

            if (element.dataset.hasOwnProperty('tabindex')) {
                element.tabIndex = Number(element.dataset.tabindex);
                element.removeAttribute('data-tabindex');

                continue;
            }

            element.removeAttribute('tabindex');
        }
    }
};


/**
 * URLパラメーター連想配列取得
 * @param  {string} paramString - URLパラメータ文字列（省略可）
 * @return {Object<string, string>} - URLパラメーターを連想配列にしたもの
 */
export const getQueryParameters = (paramString) => {
    const param = paramString ? paramString : LOCATION.param;
    /** @type {Object<string, string>} - 返り値 */
    const result = {};

    // パラメータがない場合空のオブジェクトを返す
    if (param === '') {
        return result;
    }

    // パラメーターの'?'を消した後、'&'で分割 => [key=value, key=value, key=value....]
    const splitedParam = param.slice(1).split('&');

    for (const item of splitedParam) {
        // '='で分割する => [key, value]
        const [key, value] = item.split('=');

        // {key: value}の形式で追加
        result[key] = value;
    }

    return result;
};
